import { jsx } from "react/jsx-runtime";
import {
  getVariable,
  styled,
  themeable,
  useMediaPropsActive,
  useTheme
} from "@tamagui/core";
import { YStack } from "@tamagui/stacks";
import * as React from "react";
import {
  LinearGradient as ExpoLinearGradient
} from "./linear-gradient";
const LinearGradient = YStack.extractable(
  themeable(
    React.forwardRef((propsIn, ref) => {
      const props = useMediaPropsActive(propsIn);
      const { start, end, colors: colorsProp, locations, children, ...stackProps } = props;
      const colors = useThemeColors(colorsProp || []);
      return /* @__PURE__ */ jsx(LinearGradientFrame, { ref, ...stackProps, children: /* @__PURE__ */ jsx(
        ExpoLinearGradient,
        {
          start,
          end,
          colors,
          locations,
          style: absoluteFill,
          children
        }
      ) });
    })
  )
);
const absoluteFill = {
  position: "absolute",
  top: 0,
  left: 0,
  right: 0,
  bottom: 0
};
const LinearGradientFrame = styled(YStack, {
  name: "LinearGradient",
  overflow: "hidden",
  position: "relative"
});
const useThemeColors = (colors) => {
  const theme = useTheme();
  return colors.map((color) => {
    if (color[0] === "$") {
      return getVariable(theme[color] || color);
    }
    return color;
  });
};
export {
  LinearGradient
};
//# sourceMappingURL=LinearGradient.shared.js.map
